import { render, staticRenderFns } from "./BaseDropdownItems.vue?vue&type=template&id=1b70c812&scoped=true&"
import script from "./BaseDropdownItems.vue?vue&type=script&lang=js&"
export * from "./BaseDropdownItems.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropdownItems.vue?vue&type=style&index=0&id=1b70c812&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b70c812",
  null
  
)

export default component.exports